import React, { useState } from "react";
import { TopButs } from "./TopButs";
import { FormBox } from "./FormBox";
import { TableBox } from "./TableBox";
import { FixedBottom } from "./FixedBottom";
import useNavModel, { RouterParamType } from "@/model/navModel";

export const BmsSaleSoDetails = () => {
    const { getSelectedNavState } = useNavModel(() => []);
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);

    return (
        <>
            {detailsInfo && <>
                <TopButs {...detailsInfo} />
                <FormBox {...detailsInfo} />
                <TableBox  {...detailsInfo} />
                <FixedBottom {...detailsInfo} />
            </>
            }
        </>
    )
}